import { Story } from "@/components/builder/stories/context";
import type StoriesService from "@/services/stories-service";
import { createContext, useContext } from "react";

export interface StoriesListContextType {
  service: StoriesService;

  storiesPerLoad: number;
  filter: StoriesFilter;

  genres: string[];
  loadingGenres: boolean;
  selectGenres: (selectedGenres: string[]) => void;

  page: number;
  stories: Set<Story>;
  loadingStories: boolean;
  moreStoriesAvailable: boolean;
  loadMoreStories: () => void;
}

export const StoriesListContext = createContext<StoriesListContextType | null>(null);

export interface StoriesFilter {
  genres: string[];
  startDate?: Date;
  endDate?: Date;
  excludeIdsIfNoGenreFilterIsActive: string[];
}

export function useStoriesListContext() {
  const ctx = useContext(StoriesListContext);
  if (!ctx) {
    throw new Error("useStoriesListContext must be used within a <StoriesListContextProvider/>");
  }

  return ctx;
}
